module.exports = __webpack_public_path__ + "img/蓍草.bfe0e8a7.jpg";